import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { UserSummaryType } from '../../../../../../../api/types/user/user-summary.type';
import { Checkbox } from 'primereact/checkbox';
import { AttendanceType } from '../../../../../../../api/types/lecturers/attendance/attendance-type';
import React, { useCallback, useState } from 'react';
import { UserAttendanceRequest } from '../../../../../../../api/types/lecturers/attendance/user-attendance-request';

export interface LectureAttendanceDetailsResponse {
  attendanceType?: AttendanceType;
  student: UserSummaryType;
}
interface AttendanceDataFormModel {
  attendanceDataModel: LectureAttendanceDetailsResponse[];
  handleCompleteLecture: (attendance: UserAttendanceRequest[]) => void;
}
export const AttendanceDataForm: React.FC<AttendanceDataFormModel> = ({
  attendanceDataModel,
  handleCompleteLecture,
}) => {
  const [shouldAllowComplete, setShouldAllowComplete] = useState(false);

  const [attendanceData, setAttendanceData] = useState<UserAttendanceRequest[]>(
    attendanceDataModel.map((item) => ({
      studentId: item.student.id,
      attendance: item.attendanceType ?? AttendanceType.Missed,
    })),
  );

  const handleAttendanceChange = (
    e: any,
    studentId: number,
    status: AttendanceType,
  ) => {
    setAttendanceData((prevState) =>
      prevState.map((item) => {
        if (item.studentId === studentId) {
          // If the checkbox is being checked, set to the new status
          if (e.checked) {
            return { ...item, attendance: status };
          }
          // If the checkbox is being unchecked, set to Missed
          return { ...item, attendance: AttendanceType.Missed };
        }
        return item;
      }),
    );
  };

  const getUserAttendance = useCallback((): UserAttendanceRequest[] => {
    return attendanceData.map(
      (item) =>
        ({
          studentId: item.studentId,
          attendance: item.attendance,
        }) as UserAttendanceRequest,
    );
  }, [attendanceData]);

  return (
    <div>
      <DataTable
        key={JSON.stringify(attendanceData)}
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        selectionMode={'multiple'}
        multiple={true}
        groupRowsBy="dsf"
        value={attendanceDataModel ?? []}
        selection={[]}
        onSelectionChange={(e) => {
          console.log(e);
          //setSelectedUsers(e.value as UserSummaryType[]);
        }}
        dataKey="student.id"
        tableStyle={{
          direction: 'rtl',
          marginTop: '16px',
        }}
      >
        <Column
          style={{ textAlign: 'right' }}
          field="paymentServiceName"
          body={(rowData: LectureAttendanceDetailsResponse) => (
            <div>
              {rowData.student.firstName} {rowData.student.lastName}
            </div>
          )}
          header="שם הסטודנט"
        />

        <Column
          style={{ textAlign: 'right' }}
          field="nationalId"
          header="ת.ז"
          body={(rowData: LectureAttendanceDetailsResponse) => (
            <div>{rowData.student.nationalId}</div>
          )}
        />

        <Column
          style={{ textAlign: 'right' }}
          field="attendance"
          header="נוכחות"
          body={(rowData: LectureAttendanceDetailsResponse) => (
            <Checkbox
              checked={
                attendanceData.find(
                  (data) => data.studentId === rowData.student.id,
                )?.attendance === AttendanceType.Attended
              }
              onChange={(e) =>
                handleAttendanceChange(
                  e,
                  rowData.student.id,
                  AttendanceType.Attended,
                )
              }
            />
          )}
        />
        <Column
          style={{ textAlign: 'right' }}
          field="late"
          header="איחור"
          body={(rowData: LectureAttendanceDetailsResponse) => (
            <Checkbox
              checked={
                attendanceData.find(
                  (data) => data.studentId === rowData.student.id,
                )?.attendance === AttendanceType.Late
              }
              onChange={(e) =>
                handleAttendanceChange(
                  e,
                  rowData.student.id,
                  AttendanceType.Late,
                )
              }
            />
          )}
        />
        <Column
          style={{ textAlign: 'right' }}
          field="missed"
          header="חיסור"
          body={(rowData: LectureAttendanceDetailsResponse) => (
            <Checkbox
              checked={
                attendanceData.find(
                  (data) => data.studentId === rowData.student.id,
                )?.attendance === AttendanceType.Missed
              }
              onChange={(e) =>
                handleAttendanceChange(
                  e,
                  rowData.student.id,
                  AttendanceType.Missed,
                )
              }
            />
          )}
        />
      </DataTable>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'left',
          marginTop: '8px',
          paddingBottom: '10px',
        }}
      >
        <Button
          style={{ height: '30px' }}
          severity={'secondary'}
          outlined={true}
          label={'ביטול'}
          onClick={() => setShouldAllowComplete(false)}
        />

        <div style={{ width: '10px' }} />
        <Button
          style={{ height: '30px' }}
          label={'אישור'}
          onClick={() => handleCompleteLecture(getUserAttendance())}
        />
      </div>
    </div>
  );
};
